import React, { FormEvent, useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import { Alert, Button, IconButton, InputLabel, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { IShipmentHistory, IShipmentHistoryAddRequest } from '../../types/shipment';

import { ShipmentService } from '../../services/shipmentService';
import { UtilityService } from '../../services/utilityService';

import Spinner from '../spinner';

import '../../styles/shipmentHistoryForm.scss';

export interface IShipmentHistoryForm {
	id: string;
}

const ShipmentHistoryForm: React.FunctionComponent<IShipmentHistoryForm> = ({ id }) => {
	const [shipmentHistory, setShipmentHistory] = useState<IShipmentHistory[]>([]);
	const [isLoadingHistory, setIsLoadingHistory] = useState(false);
	const [isAddingComment, setIsAddingComment] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [commentField, setCommentField] = useState<string>('');

	useEffect(() => {
		getShipmentHistory();
	}, [id])	

	const getShipmentHistory = () => {
		setIsLoadingHistory(true);

		ShipmentService.getShipmentHistory(id)
			.then((response) => {
				console.log('ShipmentService.getShipmentHistory: SUCCESS', response);
				const comments = ShipmentService.mapShipmentHistories(response.data); 
				setShipmentHistory(comments.sort((a, b) => UtilityService.compareNumbers(b.date.getTime(), a.date.getTime())));
			})
			.catch((error) => {
				console.log('ShipmentService.getShipmentHistory: ERROR', error);
				setErrorMessage("We encountered an error while loading shipment history. Please try again.");
			})
			.finally(() => {				
				setIsLoadingHistory(false);
			});
	}

	const handleAdd = async (event: FormEvent<HTMLFormElement>) => {
		if (commentField.trim() === '') {
			return;
		}

		setIsAddingComment(true);

		const request: IShipmentHistoryAddRequest = {
			description: commentField.trim()
		}
		ShipmentService.addHistoryComment(id, request)
			.then((response) => {
				console.log('ShipmentService.addHistoryComment: SUCCESS', response);
				var newComment = ShipmentService.mapShipmentHistory(response.data);
				setShipmentHistory([...shipmentHistory, newComment].sort((a: IShipmentHistory, b: IShipmentHistory) => UtilityService.compareNumbers(b.date.getTime(), a.date.getTime())));
				setCommentField('');
			})
			.catch((error) => {
				console.log('ShipmentService.addHistoryComment: ERROR', error);
				setErrorMessage("We encountered an error while posting the comment. Please try again.");
			})
			.finally(() => {
				setIsAddingComment(false);
			});
	}

	return (
		<section className="hwi-shipment-history-form">
			<Spinner dependency={isLoadingHistory} text="Loading shipment history...">
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					{errorMessage &&
						<Alert className="alert-error" severity="error" action={<IconButton onClick={() => { setErrorMessage(undefined); }} size='small'>X</IconButton>}>{errorMessage}</Alert>
					}
					<Form onSubmit={(event) => handleAdd(event)}>
						<div className="row">
							<div className="col-comment">
								<InputLabel>Comment</InputLabel>
								<TextField className="comment-field"
									value={commentField}
									fullWidth
									onChange={(event) => { setCommentField(event.target.value) }}
								></TextField>
							</div>
							<div className="col-controls">
								<Button variant="contained" fullWidth type="submit" className="save-button" disabled={(isAddingComment) ? true : false} >{isAddingComment ? "Adding..." : "Add"}</Button>
							</div>
						</div>
					</Form>
					<div className="history-table">
						<div className="headers">
							<div className="col-date">Date</div>
							<div className="col-type">Type</div>
							<div className="col-username">User</div>
							<div className="col-description">Comment</div>
							{/* <div className="col-contorls"></div> */}
						</div>
						<div className="body">
							{shipmentHistory.length > 0 ? (
								<>
									{shipmentHistory.map((item, index) => (
										<div className="row" key={index}>
											<div className="col-date"><span>{dayjs(item.date).format('MM/DD/YYYY h:mm A')}</span></div>
											<div className="col-type">{item.type}</div>
											<div className="col-username">{item.username }</div>
											<div className="col-description">{item.description}</div>
											{/* <div className="col-controls">
												<Button onClick={() => handleRemove(item.id)} disabled={(isAdding || isRemovingId) ? true : false}>{isRemovingId == item.id ? "Removing..." : "Remove"}</Button>
											</div> */}
										</div>
									))}
								</>
							) : (
								<div className="no-results">This shipment has no change history.</div>
							)}
						</div>
					</div>
					{/* <Json data={shipmentHistory}></Json> */}
				</LocalizationProvider>
			</Spinner>
		</section>
	)
}

export default ShipmentHistoryForm;